import _assertThisInitialized from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _get from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/get";
import _inherits from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _classCallCheck from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/createClass";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
import { EditorCommand, registerEditorCommand } from '../editorExtensions.js';
import { IContextKeyService, RawContextKey } from '../../../platform/contextkey/common/contextkey.js';
import { CancellationTokenSource } from '../../../base/common/cancellation.js';
import { LinkedList } from '../../../base/common/linkedList.js';
import { createDecorator } from '../../../platform/instantiation/common/instantiation.js';
import { registerSingleton } from '../../../platform/instantiation/common/extensions.js';
var IEditorCancellationTokens = createDecorator('IEditorCancelService');
var ctxCancellableOperation = new RawContextKey('cancellableOperation', false);
registerSingleton(IEditorCancellationTokens, /*#__PURE__*/function () {
  function _class() {
    _classCallCheck(this, _class);

    this._tokens = new WeakMap();
  }

  _createClass(_class, [{
    key: "add",
    value: function add(editor, cts) {
      var data = this._tokens.get(editor);

      if (!data) {
        data = editor.invokeWithinContext(function (accessor) {
          var key = ctxCancellableOperation.bindTo(accessor.get(IContextKeyService));
          var tokens = new LinkedList();
          return {
            key: key,
            tokens: tokens
          };
        });

        this._tokens.set(editor, data);
      }

      var removeFn;
      data.key.set(true);
      removeFn = data.tokens.push(cts);
      return function () {
        // remove w/o cancellation
        if (removeFn) {
          removeFn();
          data.key.set(!data.tokens.isEmpty());
          removeFn = undefined;
        }
      };
    }
  }, {
    key: "cancel",
    value: function cancel(editor) {
      var data = this._tokens.get(editor);

      if (!data) {
        return;
      } // remove with cancellation


      var cts = data.tokens.pop();

      if (cts) {
        cts.cancel();
        data.key.set(!data.tokens.isEmpty());
      }
    }
  }]);

  return _class;
}(), true);
export var EditorKeybindingCancellationTokenSource = /*#__PURE__*/function (_CancellationTokenSou) {
  _inherits(EditorKeybindingCancellationTokenSource, _CancellationTokenSou);

  var _super = _createSuper(EditorKeybindingCancellationTokenSource);

  function EditorKeybindingCancellationTokenSource(editor, parent) {
    var _this;

    _classCallCheck(this, EditorKeybindingCancellationTokenSource);

    _this = _super.call(this, parent);
    _this.editor = editor;
    _this._unregister = editor.invokeWithinContext(function (accessor) {
      return accessor.get(IEditorCancellationTokens).add(editor, _assertThisInitialized(_this));
    });
    return _this;
  }

  _createClass(EditorKeybindingCancellationTokenSource, [{
    key: "dispose",
    value: function dispose() {
      this._unregister();

      _get(_getPrototypeOf(EditorKeybindingCancellationTokenSource.prototype), "dispose", this).call(this);
    }
  }]);

  return EditorKeybindingCancellationTokenSource;
}(CancellationTokenSource);
registerEditorCommand(new ( /*#__PURE__*/function (_EditorCommand) {
  _inherits(_class2, _EditorCommand);

  var _super2 = _createSuper(_class2);

  function _class2() {
    _classCallCheck(this, _class2);

    return _super2.call(this, {
      id: 'editor.cancelOperation',
      kbOpts: {
        weight: 100
        /* EditorContrib */
        ,
        primary: 9
        /* Escape */

      },
      precondition: ctxCancellableOperation
    });
  }

  _createClass(_class2, [{
    key: "runEditorCommand",
    value: function runEditorCommand(accessor, editor) {
      accessor.get(IEditorCancellationTokens).cancel(editor);
    }
  }]);

  return _class2;
}(EditorCommand))());